var map = {
	"./Abhishek.png": 3290,
	"./chegg.png": 5215,
	"./coursera.png": 4073,
	"./coursera_logo.png": 1877,
	"./deeplearning_ai_logo.png": 2862,
	"./hackerrank.png": 9884,
	"./kgp.png": 1231,
	"./kmps.png": 9439,
	"./ktj.png": 514,
	"./qurve.png": 1955,
	"./techno.png": 9294,
	"./vani.png": 3415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;